module.exports = __webpack_public_path__ + "img/dc_rep_member_page_card_1.19aa1c1c.png";